import { PLATFORM_ANONYMOUS_ENDPOINT } from "../constants";
import { trimEndSlash } from "../helpers";
export class PlatformRequestService {
    constructor(url, siteId, ajaxService) {
        this.baseAnynomousApiUrl = url;
        this.siteId = siteId;
        this.ajaxService = ajaxService;
    }
    ;
    getAnonymousToken() {
        return this.ajaxService
            .send(`${trimEndSlash(this.baseAnynomousApiUrl)}/${trimEndSlash(PLATFORM_ANONYMOUS_ENDPOINT)}/${this.siteId}`)
            .then(response => {
            if (response.status < 200 || response.status > 299) {
                throw new Error(response.statusText);
            }
            return response.text();
        })
            .then(response => this.getParsedToken(response))
            .catch(err => { throw new Error(err); });
    }
}
//# sourceMappingURL=PlatformRequestService.js.map